// Footer markup. Its CSS is static, in index.html (with the header's), so
// nothing here is injected at runtime.

export const css = ``;

export function footerHtml() {
  const year = new Date().getFullYear();
  return `
    <div class="container">
      <div class="footer-top">
        <a href="/" class="logo" data-link aria-label="jwk.dk — home">
          <span class="logo-symbol" aria-hidden="true">&lt;/&gt;</span>
          <span>Jonas<span class="logo-dot">.</span></span>
        </a>
        <p>Hand-coded. No frameworks.</p>
      </div>
      <div class="footer-bottom">
        <span>&copy; ${year} Jonas Wendt Knudsen. All rights reserved.</span>
        <button type="button" data-back-to-top>Back to top ↑</button>
      </div>
    </div>
  `;
}

export function initFooter() {
  const footer = document.getElementById('footer');
  if (!footer) return;
  footer.innerHTML = footerHtml();

  // A button, not href="#": a fragment link would fire popstate, and the
  // router would re-render the whole route just to scroll up.
  footer.querySelector('[data-back-to-top]')?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// Called once route content is actually in the DOM.
export function markFooterReady() {
  const footer = document.getElementById('footer');
  if (footer) footer.classList.add('footer-ready');
}
